import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Typography, 
  Paper,
  Button
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface LocationState {
  nextAvailable?: string;
}

const ThankYou: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [timeUntilNext, setTimeUntilNext] = useState<string>('');
  
  useEffect(() => {
    const state = location.state as LocationState;
    if (state?.nextAvailable) {
      const nextDate = new Date(state.nextAvailable);
      const now = new Date();
      
      if (nextDate.getDate() === now.getDate() + 1) {
        setTimeUntilNext('tomorrow');
      } else {
        setTimeUntilNext(nextDate.toLocaleDateString());
      }
    }
  }, [location]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0A0B1E 0%, #1A1B3E 100%)',
        padding: theme.spacing(4),
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            p: 6,
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            borderRadius: 2,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 700,
              mb: 4
            }}
          >
            Congrats on starting your journey!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.primary,
              fontSize: '1.1rem',
              lineHeight: 1.6,
              mb: 4,
              maxWidth: '800px',
              mx: 'auto'
            }}
          >
            In our renowned curriculum, we use 10 Pillars of High Performance Living to help us understand our progress as it relates to our Whole Human. Before seeing how you scored across these, let's learn what they are first. As you progress through different modules, we will update your progress accordingly.
          </Typography>

          {timeUntilNext && (
            <Typography
              sx={{
                color: theme.palette.primary.main,
                mb: 4,
                fontSize: '1.1rem'
              }}
            >
              You can submit new responses {timeUntilNext === 'tomorrow' 
                ? 'tomorrow' 
                : `on ${timeUntilNext}`}
            </Typography>
          )}

          <Box sx={{ 
            display: 'flex', 
            gap: 2, 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Button
              variant="contained"
              onClick={() => navigate('/history')}
              sx={{
                minWidth: 200,
                py: 1.5
              }}
            >
              View Your History
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/')}
              sx={{
                minWidth: 200,
                py: 1.5,
                borderColor: 'rgba(255,255,255,0.3)',
                color: 'white',
                '&:hover': {
                  borderColor: 'rgba(255,255,255,0.5)',
                  background: 'rgba(255,255,255,0.05)'
                }
              }}
            >
              Return Home
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ThankYou;